import { useRef, useEffect } from 'react';
import logoOFII        from '../assets/imagesLand/OFII.png';
import logoVolkeno     from '../assets/imagesLand/volkeno.png';
import logoMVP         from '../assets/imagesLand/mvp.png';
import logoKPC         from '../assets/imagesLand/kpc.png';
import logoImpactHub   from '../assets/imagesLand/hub.png';
import logoPitchPalabre from '../assets/imagesLand/pp.png';
import logoOrange      from '../assets/imagesLand/Orange.png';

const PARTNERS = [
  { src: logoOFII,          alt: 'OFII'             },
  { src: logoVolkeno,       alt: 'Volkeno'          },
  { src: logoMVP,           alt: 'MVP Lab 221'      },
  { src: logoKPC,           alt: 'KPC Consortium'   },
  { src: logoImpactHub,     alt: 'Impact HUB Dakar' },
  { src: logoPitchPalabre,  alt: 'Pitch Palabre'    },
  { src: logoOrange,        alt: 'Orange'           },
];

// On duplique pour un scroll infini fluide
const LOOP = [...PARTNERS, ...PARTNERS];

export default function PartenairesSection() {
  const trackRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    let animId: number;
    let pos = 0;
    const speed = 0.5; // px par frame

    const tick = () => {
      pos += speed;
      // La moitié = largeur d'un set complet → on repart à 0
      if (pos >= track.scrollWidth / 2) pos = 0;
      track.style.transform = `translateX(-${pos}px)`;
      animId = requestAnimationFrame(tick);
    };

    animId = requestAnimationFrame(tick);

    // Pause au survol / touch
    const stop  = () => cancelAnimationFrame(animId);
    const start = () => { animId = requestAnimationFrame(tick); };

    track.addEventListener('mouseenter', stop);
    track.addEventListener('mouseleave', start);
    track.addEventListener('touchstart', stop,  { passive: true });
    track.addEventListener('touchend',   start, { passive: true });

    return () => {
      cancelAnimationFrame(animId);
      track.removeEventListener('mouseenter', stop);
      track.removeEventListener('mouseleave', start);
      track.removeEventListener('touchstart', stop);
      track.removeEventListener('touchend',   start);
    };
  }, []);

  return (
    <section className="bg-white py-[85px] mt-[60px]">

      {/* Header */}
      <div className="text-center mb-14 px-6">
        <h2 className="text-[clamp(24px,5vw,38px)] font-black text-[#1a1a1a] mb-[10px]">
          Nos Partenaires Institutionnels
        </h2>
        <p className="text-[16px] font-normal text-black leading-[1.6]">
          Ils nous accompagnent dans notre mission de digitalisation du commerce
        </p>
      </div>

      {/* ── Desktop : grille centrée ── */}
      <div className="hidden md:flex items-center justify-center gap-8 flex-wrap max-w-[1100px] mx-auto px-6">
        {PARTNERS.map((p, i) => (
          <PartnerCard key={i} {...p} />
        ))}
      </div>

      {/* ── Mobile / tablette : carrousel infini ── */}
      <div className="md:hidden overflow-hidden w-full">
        <div ref={trackRef} className="flex gap-3 w-max will-change-transform">
          {LOOP.map((p, i) => (
            <PartnerCard key={i} {...p} />
          ))}
        </div>
      </div>

    </section>
  );
}

function PartnerCard({ src, alt }: { src: string; alt: string }) {
  return (
    <div className="flex items-center justify-center shrink-0 opacity-85 transition-all duration-200 cursor-pointer bg-white rounded-lg px-3 py-2 shadow-[0_4px_14px_rgba(0,0,0,0.08)] hover:opacity-100 hover:scale-105 hover:shadow-[0_8px_24px_rgba(0,0,0,0.14)]">
      <img
        src={src}
        alt={alt}
        className="w-[90px] h-[60px] object-contain block"
      />
    </div>
  );
}